import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class VisaInventoryService {

  private _visaInventoryapiUrl = `${environment.inventory}`

  constructor(
    private _http: HttpClient
  ) { }

  addVisaInformationForCountry(formData: any):Observable<any>{
    return this._http.post(`${this._visaInventoryapiUrl}/addcountrydetails`, formData);
  }

  getAllVisaInformationForCountry(pageNo:any, pageSize:any, token:any, searchKeyword:any, filters: any): Observable<any>{
    const paginationSettings = {
      pageNumber: pageNo || 1,
      pageSize: pageSize || 20,
      search: searchKeyword || "",
      filters: filters
    }
    return this._http.post(`${this._visaInventoryapiUrl}/countries`, paginationSettings);
  }

  getVisaInformationForCountryById(id:any): Observable<any>{
    return this._http.get(`${this._visaInventoryapiUrl}/getcountrydetails/${id}`);
  }

  deleteVisaInformationForCountryById(id:any): Observable<any>{
    return this._http.delete(`${this._visaInventoryapiUrl}/deletecountrydetails/${id}`);
  }

  checkForExistingCountry(countryName:any): Observable<any>{
    return this._http.get(`${environment.inventory}/getcountryId/${countryName}`);
  }

  performBulkActions(req:any): Observable<any>{
    return this._http.put<any>(`${environment.travel}/updatecountries`, req)
  }
}
